import React from 'react';
import ProductCardDescriptionStyled from './bundle.esm2.js';

const ProductCardDescription = (props) => {
  const { className, product } = props;
  const { description } = product;
  return /* @__PURE__ */ React.createElement(ProductCardDescriptionStyled, {
    className: `ProductCardDescription ${className}`,
    title: description
  }, description);
};
ProductCardDescription.defaultProps = {
  className: ""
};

export { ProductCardDescription as default };
//# sourceMappingURL=bundle.esm.js.map
